import React from 'react'

interface RatingContextProps {
  language: string
  configId: string
  apiKey: string
  isFrame: boolean
  variant: string
  appName: string
  isTest: boolean
  loading: boolean
  setLoading: (isLoading: boolean) => void
  preCheck: boolean
  setPreCheck: (isChecked: boolean) => void
  formCompleted: boolean
  setFormCompleted: (isCompleted: boolean) => void
  formError: boolean
  setFormError: (hasError: boolean) => void
  requestError: boolean
  setRequestError: (hasError: boolean) => void
  errorCode: string
  setErrorCode: (newError: string) => void
  guidedToggle: boolean
  setGuidedToggle: (isGuidedToggle: boolean) => void
  rating: number
  setRating: (rate: number) => void
}

export const RatingContext = React.createContext<RatingContextProps>({
  language: '',
  configId: '',
  apiKey: '',
  isFrame: false,
  variant: '',
  appName: '',
  isTest: false,
  loading: false,
  setLoading: () => {},
  preCheck: true,
  setPreCheck: () => {},
  formCompleted: false,
  setFormCompleted: () => {},
  formError: false,
  setFormError: () => {},
  requestError: false,
  setRequestError: () => {},
  errorCode: '301',
  setErrorCode: () => {},
  guidedToggle: false,
  setGuidedToggle: () => {},
  rating: 0,
  setRating: () => {}
})
